import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { SessionContext } from './StoreProvider';
import Template from '../components/templates/default';
import Main from './Main';
import Activation from '../components/organisms/activation';
import { getOfferFromURL } from '../helpers';
import { assign as navigate } from '../routes';

const ActivationContainer = ({ submitActivation, user }) => {
  const [loading, setLoading] = useState(false);

  const activationSuccess = () => {
    setTimeout(() => {
      window.nossaContainer.refreshUser();
      setLoading(false);
      navigate('/ativacao/sucesso');
    }, 3000);
  };
  const activationError = status => {
    setLoading(false);
    if (status === 400) {
      navigate('/ativacao/erro-usuario');
    } else {
      navigate('/ativacao/erro');
    }
  };
  const submitTaste = () => {
    setLoading(true);
    submitActivation(
      { offer: getOfferFromURL(), nossaId: user.authentication.uid },
      activationSuccess,
      activationError
    );
  };
  return (
    <Template className="activation-page">
      <Main>
        <Activation loading={loading} submitTaste={submitTaste} />
      </Main>
    </Template>
  );
};

ActivationContainer.defaultProps = {
  user: {}
};

ActivationContainer.propTypes = {
  submitActivation: PropTypes.func.isRequired,
  user: PropTypes.shape({
    userInfo: PropTypes.object,
    authentication: PropTypes.object
  })
};

export default props => (
  <ActivationContainer {...useContext(SessionContext)} {...props} />
);
